import React from 'react';
import PropTypes from 'prop-types';

const SvgIcon = ({ name }) => {
  const [svg, setSvg] = React.useState('');

  React.useEffect(() => {
    fetch(`/r2/img/${name}.svg`)
      .then((response) => response.text())
      .then((_svg) => {
        setSvg(_svg);
      });
  }, [name]);

  if (!svg) {
    return null;
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: svg,
      }}
    />
  );
};

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default SvgIcon;
